module.exports = __webpack_public_path__ + "static/media/overall-time.74e7f20d.svg";